import { Icon } from "components/SvgIcons";
import React, { useState, useEffect } from "react";
import {
  CheckboxWrap,
  CheckboxText,
  CheckboxIcon,
} from "shared/Checkbox/styled";

const Checkbox = ({ text, onChange, checked, children, rerender = false }) => {
  const [state, setState] = useState(false);
  useEffect(() => {
    if (rerender && !state) {
      setState(true);
      setTimeout(() => setState(false), 1);
    }
  }, []);

  if (state) {
    return <div />;
  }
  return (
    <CheckboxWrap>
      <input
        type="checkbox"
        name="checkbox"
        onChange={onChange}
        checked={checked}
      />
      <CheckboxIcon className="checked">
        <Icon icon="check" />
      </CheckboxIcon>
      <CheckboxText>{text || children}</CheckboxText>
    </CheckboxWrap>
  );
};

export default Checkbox;
